import { render, staticRenderFns } from "./login_cliente.vue?vue&type=template&id=32b6bcd3&scoped=true&"
import script from "./login_cliente.vue?vue&type=script&lang=js&"
export * from "./login_cliente.vue?vue&type=script&lang=js&"
import style0 from "./login_cliente.vue?vue&type=style&index=0&id=32b6bcd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b6bcd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VProgressCircular,VRow})
